class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.currentStep = 0;
    this.previousStep = 0;
  }

  connectedCallback() {
    this.currentStep = parseInt(this.dataset.currentStep || '0', 10);
    this.previousStep = this.currentStep;
    this.#addEventListeners();
    // this.#getCurrentStep();
    this.#observeStepChanges();
  }

  async #getCurrentStep() {
    // fetch data cart
    const cartData = await fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        }
      })
    const cartDataJson = await cartData.json()
    let mainItem = 0
    cartDataJson.items.forEach(item => {
      if (!item?.properties?._parent && !item?.properties?._card) {
        mainItem = mainItem + item.quantity;
      }
    });
    this.setStep(mainItem);
  }

  #addEventListeners() {
    const offerModal = this.closest('offer-modal');
    if (offerModal) {
      offerModal.addEventListener('update-progress', (event) => {
        this.setStep(event.detail.step);
      });
    }

    const customPersonalizer = this.closest('custom-personalizer');
    if (customPersonalizer) {
      customPersonalizer.addEventListener('update-progress', (event) => {
        this.setStep(event.detail.step);
      });
    }

    const newPersonalizer = this.closest('new-personalizer');
    if (newPersonalizer) {
      newPersonalizer.addEventListener('update-progress', (event) => {
        this.setStep(event.detail.step);
      });
    }
  }

  #observeStepChanges() {
    const observer = new MutationObserver(() => {
      const newStep = parseInt(this.dataset.currentStep || '0', 10);
      if (newStep !== this.currentStep) {
        this.setStep(newStep);
      }
    });

    observer.observe(this, {
      attributes: true,
      attributeFilter: ['data-current-step']
    });
  }

  #updateProgress(showFireworks = true) {
    const steps = this.querySelectorAll('.progress-bar__step');
    const previousStep = this.previousStep || 0;

    steps.forEach((step, index) => {
      const stepNumber = index + 1;

      step.classList.remove('progress-bar__step--completed', 'progress-bar__step--active', 'progress-bar__step--inactive');
      if (stepNumber <= this.currentStep) {
        step.classList.add('progress-bar__step--completed');

        if (showFireworks && stepNumber === this.currentStep && stepNumber > previousStep) {
          this.#createFireworks(step);
        }
      } else if (stepNumber === this.currentStep + 1) {
        step.classList.add('progress-bar__step--active');
      } else {
        step.classList.add('progress-bar__step--inactive');
      }
    });

    this.previousStep = this.currentStep;
    this.#updateLineProgress();
  }

  #goToStep(step) {
    const ctaText = this.querySelector('.progress-bar__cta-text');
    this.#updateHeader();
    this.#updateCTA(ctaText);
  }

  #updateLineProgress() {
    const lineProgress = this.querySelector('.progress-bar__line-progress');
    const targetWidth = [65, 140];

    requestAnimationFrame(() => {
      lineProgress.style.width = `${targetWidth[this.currentStep - 1]}%`;
    });
  }

  #createFireworks(stepElement) {
    const colors = ['#BFA87D', '#D4AF37', '#ff6b9d', '#ffa06b', '#667eea', '#764ba2'];
    const particleCount = 200;
    const stepIcon = stepElement.querySelector('.progress-bar__step-icon');

    if (!stepIcon) return;

    const rect = stepIcon.getBoundingClientRect();
    const containerRect = this.getBoundingClientRect();
    const x = rect.left + rect.width / 2 - containerRect.left;
    const y = rect.top + rect.height / 2 - containerRect.top;

    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      particle.className = 'firework-particle';

      const angle = (Math.PI * 2 * i) / particleCount;
      const velocity = 50 + Math.random() * 50;
      const tx = Math.cos(angle) * velocity;
      const ty = Math.sin(angle) * velocity;

      particle.style.left = x + 'px';
      particle.style.top = y + 'px';
      particle.style.background = colors[Math.floor(Math.random() * colors.length)];
      particle.style.setProperty('--tx', tx + 'px');
      particle.style.setProperty('--ty', ty + 'px');

      this.appendChild(particle);

      setTimeout(() => {
        if (particle.parentNode) {
          particle.remove();
        }
      }, 3000);
    }
  }

  #updateHeader() {
    const titles = this.querySelectorAll('.progress-bar__title');
    titles.forEach((title, index) => {
      const number = index + 1;
      if (number === this.currentStep) {
        title.style.display = 'block';
      } else {
        title.style.display = 'none';
      }
    });
  }

  #updateCTA(ctaText) {
    if (!ctaText) return;

    const ctaMessages = {
      0: 'Add one more to claim your <span class="progress-bar__cta-highlight">REWARD</span> and save instantly!',
      1: '<span class="progress-bar__cta-highlight">Checkout now</span> or keep customizing to unlock it again',
    };

    ctaText.innerHTML = ctaMessages[this.currentStep - 1] || ctaMessages[0];
  }

  #resetStep() {
    const steps = this.querySelectorAll('.progress-bar__step');
    steps.forEach((step, index) => {
      const stepNumber = index + 1;
      if (stepNumber >= this.currentStep) {
        step.classList.remove('progress-bar__step--completed', 'progress-bar__step--inactive');
        step.classList.add('progress-bar__step--active');
      }
    });
    const lineProgressWidth = (this.currentStep - 1) * 50;
    const lineProgress = this.querySelector('.progress-bar__line-progress');
    lineProgress.style.width = `${lineProgressWidth}%`;
  }

  setStep(step) {
    const newStep = step % 2 === 0 ? 2 : 1;
    this.currentStep = newStep;
    this.previousStep = newStep - 1;

    this.#resetStep();

    setTimeout(() => {
      this.#goToStep(newStep);
      this.#updateProgress();
    }, 1000);
  }
}

customElements.define('progress-bar', ProgressBar);
